const CloseDrawerReducer = (state = 0 , action) =>{
    switch(action.type){
        case "PRODUCT_PRICE_TYPE":
        return   action.payload
        default: 
        return state
    }
}
export default CloseDrawerReducer;